import React from 'react'

import _ from 'underscore'

import {H3, S2, P, Info, Row, Colors, Card} from '../../../../components/UI/index.js'
import CarrierLogo from '../../../../components/parcels/CarrierLogo.js'
import {Check} from '../../../../components/UI/forms/index.js'
import {carrierProductSetting} from '@utils/carrierSettingProducts.js'
import t from 'src/helpers/Languages.js'

class ParcelProducts extends React.Component {
    onChangeProduct(product, carrier, event) {
        const reseller = {...this.props.reseller}

        reseller.settings.parcels.products = reseller.settings.parcels.products || {}
        reseller.settings.parcels.products[product] = reseller.settings.parcels.products[product] || {}
        reseller.settings.parcels.products[product][carrier.name] = event.target.checked

        this.props.onChange(reseller, 'parcels.products')
    }

    render() {
        const {reseller, carriers} = this.props

        const enabledCarriers = _.filter(carriers, (carrier) => {
            return reseller.settings.parcels.carriers[carrier.name] && reseller.settings.parcels.carriers[carrier.name].enabled
        })

        let products = []

        enabledCarriers.map((carrier) => {
            _.keys(carrier.products).map((product) => {
                products = _.uniq([...products, product]).sort()
            })
        })

        return (
            <Card shadow style={{padding: 24, minWidth: 600, width: 'fit-content', height: 'fit-content'}}>
                <H3 style={{marginBottom: 24}}>{t('parcelProducts')}</H3>

                {enabledCarriers.length < 1 &&
                    <S2 style={{marginBottom: 30}}>{t('parcelProductsNoCarriers')}</S2>
                }

                <div style={{display: 'flex', position: 'sticky', width: '100%', paddingLeft: 300, top: 0, paddingTop: 24, backgroundColor: Colors.backgroundWhite}}>
                    {enabledCarriers.map((carrier) => {
                        return (
                            <div key={`header${carrier.name}`} style={styles.column}>
                                <CarrierLogo
                                    size={45}
                                    carriers={carriers}
                                    value={carrier.name}
                                />
                                <P style={{width: 90, textAlign: 'center'}}>{carrier.displayName || carrier.name}{carrier.platform ? ` - ${carrier.platform}` : ''}</P>
                            </div>
                        )
                    })}
                </div>
                <br />

                {products.map((product, index) => {
                    if (product === 'Px' && !(reseller.name === 'Tour de Ville Eindhoven' || reseller.name === 'Tour de Ville Tilburg' || reseller.name === 'Veloyd')) {
                        return
                    }

                    return (
                        <div key={index}>
                            <div style={{...styles.row}}>
                                <P style={styles.rowHeader}>
                                    <Row>
                                        {product}

                                        {product === 'Adreslabel' &&
                                            <Info style={{marginLeft: 6}} text={t('parcelProductAddressLabelInfo')} />
                                        }

                                        {product === 'Brievenbuspakket zonder Track & Trace' &&
                                            <Info style={{marginLeft: 6}} text={t('parcelProductMailboxNoTrackTraceInfo')} />
                                        }

                                        {product === 'Retour' &&
                                            <Info style={{marginLeft: 6}} text={t('parcelProductReturnInfo')} />
                                        }

                                        {product === 'Verificatiecode' &&
                                            <Info style={{marginLeft: 6}} text={t('parcelProductVerificationCodeInfo')} />
                                        }
                                    </Row>
                                </P>

                                {enabledCarriers.map((carrier, index) => {
                                    let carrierHasProduct = !!carrier.products[product]
                                    const settingsHasProduct = carrierHasProduct && !!reseller.settings.parcels.products[product]

                                    const carrierSetting = carrierProductSetting(carrier.name, product)

                                    if (carrierHasProduct && carrierSetting) {
                                        carrierHasProduct = !!reseller.settings.parcels.carriers?.[carrier.name]?.[carrierSetting]
                                    }

                                    return (
                                        <div key={index} style={styles.column}>
                                            <Check
                                                disabled={!carrierHasProduct}
                                                checked={settingsHasProduct && reseller.settings.parcels.products[product][carrier.name]}
                                                onChange={this.onChangeProduct.bind(this, product, carrier)}
                                            />
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    )
                })}
            </Card>
        )
    }
}

const styles = {
    row: {
        display: 'flex',
        alignItems: 'center',
        marginTop: 12,
        paddingLeft: 6,
        height: 48,
        borderBottom: `1px solid ${Colors.grey20}`
    },
    rowHeader: {
        display: 'flex',
        alignItems: 'center',
        width: 300,
        height: 30
    },
    column: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: 90,
        marginRight: 12
    }
}

export default (ParcelProducts)
